
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stars-college-network",
      function () {
        return require("private-next-pages/stars-college-network/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stars-college-network"])
      });
    }
  